/**
 * Detects World Cup squad flows where the main app tab bar should hide and the FAB should not show.
 */

export const WORLD_CUP_GROUP_WIZARD_SEGMENTS = ['create', 'join', 'created'] as const;

export function isWorldCupGroupWizardPath(pathname: string): boolean {
  const segments = pathname.split('/').filter(Boolean);
  const wcIdx = segments.indexOf('worldcup');
  if (wcIdx < 0 || segments[wcIdx + 1] !== 'groups') {
    return false;
  }
  const child = segments[wcIdx + 2];
  return (
    typeof child === 'string' &&
    (WORLD_CUP_GROUP_WIZARD_SEGMENTS as readonly string[]).includes(child)
  );
}
